import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { Storage } from "../../utilities/storage";
import { Toastr } from "../../plugins/toastr/toastr";
import { AuthenticationService } from "../../services/authentication.service";
import { MessagingService } from "../../services/messaging.service";
import { CustomValidator } from "../../utilities/validator/custom-validator";

@Component({
  // selector: "app-signup",
  templateUrl: "./signup.component.html",
})
// This component is used for both reset password as well as signup
export class SignupComponent implements OnInit {
  signupForm: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;
  error: any = "";
  currentUser: any;
  public year: any;
  public date: any = new Date();
  public email: string;
  private token: string;
  private isResetPasswordLink: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    public authService: AuthenticationService,
    private router: Router,
    public storage: Storage,
    public toastr: Toastr,
    public messagingService: MessagingService,
    private route: ActivatedRoute
  ) {
    this.year = moment(this.date).format("YYYY");
  }

  ngOnInit() {
    this.signupForm = this.formBuilder.group({
      password: ["", Validators.required],
      confirm_password: ["", Validators.required],
      token: [],
    });
    this.route.url.subscribe((urls: any) => {
      this.isResetPasswordLink = urls[0].path === "reset-password";
    });
    this.route.queryParams.subscribe((queryParams: any) => {
      this.email = queryParams.email;
    });
    this.route.params.subscribe((params) => {
      this.token = params.token;
      console.log("Token", this.token);
    });
  }

  get f() {
    return this.signupForm.controls;
  }

  signup(): void {
    this.signupForm.patchValue({
      token: this.token,
    });

    this.submitted = true;

    this._startLoading();
    if (this.signupForm.invalid) {
      console.log("error");
      return;
    }

    this.authService.signup(this.signupForm.value).subscribe(
      (res) => {
        this.toastr.showSuccess(
          "Make a password validator function and signup sucess"
        );
        this.router.navigate(["pages/login"]);
        this._stopLoading();
      },
      (error) => {
        this._stopLoading();
      }
    );

    // console.log("Signup form", this.signupForm.value);

    // call push notification method here
  }

  resetPassword(): void {
    this.signupForm.patchValue({
      token: this.token,
    });

    this.submitted = true;

    this._startLoading();
    if (this.signupForm.invalid) {
      console.log("error");
      return;
    }
    console.log("RESET PASSWORD", this.signupForm.value);
    this.authService.resetPassword(this.signupForm.value).subscribe(
      (res: any) => {
        this.toastr.showSuccess("Your password is reseted successfully");
        this.router.navigate(["pages/login"]);
        this._stopLoading();
      },
      (error) => {
        this._stopLoading();
      }
    );
  }

  _initPushNotifications(userId) {
    this.messagingService.requestPermission(userId);
    this.messagingService.receiveMessage();
  }

  _startLoading() {
    this.loading = true;
  }
  _stopLoading() {
    this.loading = false;
  }
}
